import { selectAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers, cssVar, defineStyle } from '@chakra-ui/styled-system';
import { inputTheme } from './Input';
import { Colors, Space, LineHeights } from '../../types';

const { defineMultiStyleConfig, definePartsStyle } = createMultiStyleConfigHelpers(parts.keys);

const $bg = cssVar('select-bg');

const baseStyleField = defineStyle({
  ...inputTheme.baseStyle?.field,
  appearance: 'none',
  paddingInlineStart: Space.SPACE_4,
  lineHeight: LineHeights.NORMAL,
  bg: $bg.reference,
  [$bg.variable]: Colors.SURFACE_PAGE,
  '> option, > optgroup': {
    bg: $bg.reference,
  },
});

const baseStyleIcon = defineStyle({
  width: Space.SPACE_6,
  height: '100%',
  insetEnd: Space.SPACE_2,
  _disabled: {
    color: Colors.TEXT_DISABLED,
  },
});

const baseStyle = definePartsStyle({
  field: baseStyleField,
  icon: baseStyleIcon,
});

const iconSpacing = defineStyle({
  paddingInlineEnd: Space.SPACE_8,
});

const sizes = {
  lg: {
    ...inputTheme.sizes?.lg,
    field: {
      ...inputTheme.sizes?.lg.field,
      ...iconSpacing,
    },
    group: {
      ...inputTheme.sizes?.lg.group,
    },
  },
  md: {
    ...inputTheme.sizes?.md,
    field: {
      ...inputTheme.sizes?.md.field,
      ...iconSpacing,
    },
    group: {
      ...inputTheme.sizes?.md.group,
    },
  },
  sm: {
    ...inputTheme.sizes?.sm,
    field: {
      ...inputTheme.sizes?.sm.field,
      ...iconSpacing,
    },
    group: {
      ...inputTheme.sizes?.sm.group,
    },
  },
  xs: {
    ...inputTheme.sizes?.xs,
    field: {
      ...inputTheme.sizes?.xs.field,
      ...iconSpacing,
    },
    group: {
      ...inputTheme.sizes?.xs.group,
    },
    icon: {
      insetEnd: '1',
    },
  },
};

export const Select = defineMultiStyleConfig({
  baseStyle,
  sizes,
  variants: inputTheme.variants,
});
